'use client';
import { isString, isNumber, isObject } from '@s7/utils';

/** Является ли примитивным идентификатором кэша */ var isSingularIdent = function(ident) {
    return isString(ident) || isNumber(ident);
};
/** Является ли идентификатор кэша динамическим */ var isDynamicIdent = function(ident) {
    return isObject(ident);
};

export { isDynamicIdent, isSingularIdent };
